import logoImg from "@/assets/headimage/logo.png";
import ImageImg from "@/assets/image-text/image-text.png";
import EditText, {
  IforwardRef,
} from "@/pages/CreationSpace/components/EditText/EditText";
import editImg from "@/assets/create-space/edit.png";
import { useRef, useState } from "react";
import { Breadcrumb, Button } from "@arco-design/web-react";
import VoLongButton from "@/components/VLButton/VLButton";
import "./Header.less";
import { useNavigate } from "react-router-dom";
import MyTask from "@/components/UI/MyTask";
import { observer } from "mobx-react";
import appStore from "@/stores/appStore";
interface IHeader {
  disEdit?: boolean;
  name: string;
  updateTime?: number | string;
  handleChangeName: (e: string) => void;
  handleSaveBtnClick?: () => void;
  handleResultBtnClick?: () => void;
  mode?: "mixDetail" | "componse" | "imageText";
  total?: number;
  project_id?: string;
}
enum Emode {
  "mixDetail" = "视频魔剪",
  "componse" = "合成视频",
  "imageText" = "合成",
}

const Header: React.FC<IHeader> = (props) => {
  const {
    disEdit,
    name,
    mode = "mixDetail",
    handleChangeName,
    handleSaveBtnClick,
    handleResultBtnClick,
    updateTime,
    total,
  } = props;
  const inputRef = useRef<IforwardRef>(null);
  const navigator = useNavigate();
  const [showIcon, setShowIcon] = useState(false);
  return (
    <div className="header">
      <div className="header-left">
        <img
          className="log-img"
          src={appStore.config?.web?.app?.collapse_logo}
          alt=""
          onClick={() => {
            navigator("/work-bench");
          }}
        />
        {mode === "imageText" && (
          <span className="image-text-img">
            <span className="split">|</span>
            <img className="image-img" src={ImageImg} alt="" />
          </span>
        )}
        <Breadcrumb style={{ marginLeft: '10px', paddingBottom: '5px' }}>
          <Breadcrumb.Item><a onClick={() => navigator('/creative-space', { state: {type: 'ENGINEERING'}})}>创意工程</a></Breadcrumb.Item>
          <Breadcrumb.Item>{mode === "imageText" ? '图文创作' : '魔剪创作'}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div
        onMouseLeave={() => {
          setShowIcon(false);
        }}
        onMouseMove={() => {
          setShowIcon(true);
        }}
        className={"edit-wrapper-container"}
      >
        <EditText
          disabed={!disEdit}
          ref={inputRef}
          style={{
            width: "auto",
            fontWeight: "600",
            fontSize: "22px",
            color: "#333333",
          }}
          name={name}
          handleInputEndEnter={(e) => {
            handleChangeName(e);
            inputRef.current.toggleIsEdit();
          }}
        />
        {!disEdit && showIcon ? (
          <img
            src={editImg}
            onClick={() => {
              setShowIcon(false);
              inputRef.current.toggleIsEdit();
            }}
          />
        ) : (
          <></>
        )}
      </div>
      <div className="cut-detail-action">
        {updateTime ? <div className="time">{updateTime} 已保存</div> : <></>}
        {handleSaveBtnClick ? (
          <Button
            style={{ marginRight: 10 }}
            className={"button"}
            onClick={() => {
              if (handleSaveBtnClick) {
                handleSaveBtnClick();
              }
            }}
          >
            保存
          </Button>
        ) : (
          <></>
        )}
        {mode === "componse" ? (
          <>
            <MyTask />
          </>
        ) : (
          <></>
        )}
        {mode === "imageText" ? (
          <div
            onClick={() => {
              if (handleResultBtnClick) {
                if (!total) {
                  return false;
                }
                handleResultBtnClick();
              }
            }}
            className="image-btn"
            style={{
              marginLeft: "22px",
              cursor: total > 0 ? "pointer" : "no-drop",
              background:
                total > 0
                  ? "linear-gradient( 135deg, #165DFF 0%, #CB98FA 100%)"
                  : "rgb(242, 243, 245)",
              color: total > 0 ? "#ffffff" : "#333333",
            }}
          >
            合成{total > 0 && <div className="circle">{total}</div>}
          </div>
        ) : (
          <VoLongButton
            style={{ marginLeft: "22px" }}
            type="primary"
            onClick={() => {
              if (handleResultBtnClick) {
                handleResultBtnClick();
              }
            }}
          >
            {Emode[mode]}
          </VoLongButton>
        )}
      </div>
    </div>
  );
};

export default Header;
